export default __webpack_public_path__ + "static/media/vipIcon.6838f6b2.svg";